import React, { memo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { LIST_TABLE_SX } from '../mathTableStyles';
import type { MathChange } from './changesApi';

interface ChangesRowProps {
  row: MathChange;
  number: number;
  canMark: boolean;
  disabled: boolean;
  marking: boolean;
  onMark: (id: number) => void;
}

const ChangesRow = memo(({ row, number, canMark, disabled, marking, onMark }: ChangesRowProps) => (
  <tr>
    <td className="muted">{number}</td>
    <td className="strong">{row.pharmacyNum}</td>
    {canMark && (
      <td className="right">
        <button type="button" className="act ok" disabled={disabled || marking} onClick={() => onMark(row.id)}>
          {marking ? <CircularProgress size={14} color="inherit" /> : <CheckIcon />}
          Проверено
        </button>
      </td>
    )}
  </tr>
));

interface ChangesTableProps {
  /** Строки текущей страницы */
  rows: MathChange[];
  /** Сквозной номер первой строки страницы */
  firstNumber: number;
  canMark: boolean;
  /** Идет «Отметить всё»: отметки по отдельным записям недоступны */
  disabled: boolean;
  markingIds: Record<number, boolean>;
  onMark: (id: number) => void;
}

const ChangesTable: React.FC<ChangesTableProps> = ({ rows, firstNumber, canMark, disabled, markingIds, onMark }) => (
  <Box sx={LIST_TABLE_SX}>
    <table>
      <thead>
        <tr>
          <th className="narrow">№</th>
          <th>Номер аптеки</th>
          {canMark && <th className="right actions">Действия</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <ChangesRow
            key={row.id}
            row={row}
            number={firstNumber + index}
            canMark={canMark}
            disabled={disabled}
            marking={!!markingIds[row.id]}
            onMark={onMark}
          />
        ))}
      </tbody>
    </table>
  </Box>
);

export default memo(ChangesTable);
